var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenRightSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 76,
    viewBox: "0 0 17 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 75.0657V0.934259L4.73035 7.44736C2.08746 9.20929 0.5 12.1755 0.5 15.3518V60.6482C0.5 63.8245 2.08746 66.7907 4.73035 68.5526L14.5 75.0657Z",
    fill: "#FCFCFC",
    stroke: "#DDDEDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1245 39.7232L10.1293 43.728L10.8757 42.9816L7.6174 39.7232L10.8757 36.4649L10.1293 35.7184L6.1245 39.7232Z",
    fill: "#2F2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenRightSidebar);
export default __webpack_public_path__ + "static/media/OpenRightSidebar.857ecbbcdeaab27a6e330294b7bb90fc.svg";
export { ForwardRef as ReactComponent };